import React, { PropTypes } from 'react';

// Containers
import LocalContainer from '../../containers/LocalContainer';
import MetadataContainer from '../../containers/MetadataContainer';

// Components
import VisibilitySection from './VisibilitySection';
import ActionBar from './ActionBar';
import DropzoneWrapper from './DropzoneWrapper';
import History from './History';

export default class Document extends React.Component {

	constructor(props) {
		super(props);
		this.state = { files: [], savedFiles: [] };

		this.isEdit = typeof this.props.params.id !== "undefined";
		this.fileIDs = typeof this.props.params.fileIDs === "undefined" ? [] : this.processImportedFilesFromFTP();
		this.props.router.setRouteLeaveHook(this.props.route, () => {
			if ( this.props.hasEdited ) return 'Você possui alterações não salvas. Tem certeza que deseja continuar?';
		});
		// initializing loader notch icon
		// console.warn(this.isEdit)
		// if (this.isEdit === false) {
		// 	this.props.actions.isFetchingMap(true);
		// } else {
		// 	this.props.actions.isFetchingMap(false);
		// }

		window.onbeforeunload = () => {
			if ( this.props.hasEdited ) return 'Changes may be lost!';
		};
	}	

	componentWillMount() {
		const { id } = this.props.params;
		//document.log.reverse();
		// Now get the document from BD
		if ( this.isEdit && parseInt(id) !== this.props.selected ) this.props.actions.viewDocument(id);
		if ( this.isEdit ) this.refreshFiles();
		// this.actions.setHasOwner(false);

	}

	componentDidUpdate(prevProps) {
		// Checks if we have id and fileIDs is not empty, meaning the user has just created a new
		// document after exported file from FTP
		if ( typeof this.props.params.id !== "undefined" && this.fileIDs.length > 0 ) location.reload();

		// Checks if there is no params (is creating) and before it was an edit, meaning
		// user has clicked on new document while editing
		if ( typeof this.props.params.id === "undefined" && this.isEdit ) location.reload();
		this.isEdit = typeof this.props.params.id !== "undefined";

		// If we have saved our progress, than refresh files to show correct UI
		if ( prevProps.upload.status === "IN_PROGRESS" && this.props.upload.status === "SUCCESS" ) this.refreshFiles();

	}

	// This function finds the files related to a document and refreshes it
	refreshFiles() {
		const { id } = this.props.params;
		if ( typeof id === "undefined" ) return;
		this.props.actions.getDocumentFiles(id, (files) => this.setState({savedFiles: files, files: []}));		
	}

	onDrop(files) {
		this.setState({files});
	}

	onRemove(filehash, filename) {
		const m = `Tem certeza que deseja deletar ${filename}? Esse procedimento não pode ser desfeito!`;
		if ( !confirm(m) ) return;
		const { deleteFile, getDocumentFiles } = this.props.actions;
		const { selected: docId } = this.props;
		return deleteFile(
			docId, 
			filehash, 
			() => getDocumentFiles(this.props.params.id, (files) => this.setState({savedFiles: files}))
		);
	}

	handleDeleteDocument() {
		const { title } = this.props.document;
		const m = `Tem certeza que deseja deletar o documento ${title}? Esse procedimento não pode ser desfeito!`;
		if ( !confirm(m) ) return;
		this.props.actions.deleteDocument(this.props.params.id);
	}

	processImportedFilesFromFTP() {
		const arr = [];
		const splitted = this.props.params.fileIDs.split("&");
		splitted.map((f) => arr.push(f));
		return arr;
	}

	prefixPath() {
		const arr = [];
		// FTP agora passa a hash do arquivo.
		this.fileIDs.map((f) => arr.push(f));
		return arr;
	}

	generateDoc() {
		const { 
			title, url, hasOwner, isPublic, datetime, startCoverageDate,
			endCoverageDate, description, rects, points, projects, groups
		} = this.props.document;
		return {
			title,
			hasOwner: hasOwner ? 1 : 0,
			isPublic: isPublic ? 1 : 0,
			datetime,
			startCoverageDate,
			endCoverageDate,
			description,
			rects,
			points,
			url,
			themes: this.props.themesById,
			shapes: this.props.selectedShapes,
			authors: this.props.existentAndNew.authors,
			institutions: this.props.existentAndNew.institutions,
			keywords: this.props.existentAndNew.keywords,
			folder: this.props.existentAndNew.folder,
			files: this.state.files,
			fileIDs: this.prefixPath(),
			projects: projects,
			groups: groups
		};
	}
	
	getContent() {
		const { actions, selected, upload, document, downloadExported, isProcessingZip } = this.props;
		const formattedDoc = this.generateDoc();

		return this.isEdit && selected === null
			? <i className="fas fa-circle-notch fa-spin fa-fw" />
			: (
			<div>
				<DropzoneWrapper 
					files={this.state.files} 
					fileIDs={this.fileIDs} 
					isEdit={this.isEdit}
					docId={this.props.selected}
					savedFiles={this.state.savedFiles}
					downloadExported={downloadExported}
					router={this.props.route}
					downloadFile={actions.downloadFile} 
					downloadFilesAsZip={actions.downloadFilesAsZip}
					onDrop={this.onDrop.bind(this)}					
					deleteFile={this.onRemove.bind(this)}
					checkExistance={actions.checkExistance}
					salvarEnabledFunction={actions.toogleSaveButtonValue}
					isProcessingZip={isProcessingZip}
				/>
				<hr />

				<MetadataContainer />
				<hr />
				<VisibilitySection
					deleteDocument={this.props.actions.deleteDocument}
					isEdit={this.isEdit}
					setHasOwner={actions.setHasOwner}
					setIsPublic={actions.setIsPublic}
					hasOwner={document.hasOwner}
					isPublic={document.isPublic}
					project={document.projects}
					docGroup={document.groups}
					userProjectAccess={this.props.userProjectAccess}
					userGroupAccess={this.props.userGroupAccess}
				/>
				<hr />
				
				<LocalContainer
					isFetchingMap={this.props.isFetchingMap}
					isFetchingMapFunc={this.props.actions.isFetchingMap}
				/>
				<hr />				

				<ActionBar
					upload={upload}
					onSave={actions.saveDocument}
					onDelete={this.handleDeleteDocument.bind(this)}
					document={formattedDoc}
					showDelete={this.isEdit}
					selected={selected}
					salvarEnabled={this.props.salvarBtEnabled}
				/>
				<History log={document.log} />
				<div style={{marginTop: "10px", cursor: "pointer", textAlign: "center"}}>
					<a onClick={() => window.scrollTo(0, 0)}>&uarr; Voltar ao Topo</a>
				</div>
			</div>
			);
	}

	render () {
		const title = this.isEdit ? "Editar Documento" : "Criar Documento";
		let endTitle = "";
			
		if (this.isEdit) {
			if ( typeof this.props.document.projects[0] !== 'undefined') {
				endTitle = ` em ${this.props.document.projects[0].name}`;
			}
		} else {
			endTitle = window.location.href.includes("mariana") ? " em Mariana" : " em Brumadinho";
		}
		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-default">
						<div className="panel-body">
							<div>
								<h2 style={{textAlign: "center"}}>{title + endTitle}</h2>
								<hr />
								{this.getContent()}								
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Document.propTypes = {
	actions: PropTypes.object.isRequired,
	params: PropTypes.object.isRequired,
	document: PropTypes.object.isRequired,
	selectedShapes: PropTypes.array.isRequired,
	themesById: PropTypes.array.isRequired,
	hasEdited: PropTypes.bool.isRequired,
	isFetchingMap: PropTypes.bool.isRequired,
	// isFetchingMapFunc: PropTypes.func.isRequired,
	salvarBtEnabled: PropTypes.bool.isRequired,
	existentAndNew: PropTypes.object.isRequired,
	upload: PropTypes.object.isRequired,
	router: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	downloadExported: PropTypes.func.isRequired,
	selected: PropTypes.number,
	userProjectAccess: PropTypes.array.isRequired,
	userGroupAccess: PropTypes.array.isRequired,
	isProcessingZip: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/Document.js